import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { TaskBankAccount } from "@models/task-request";
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { DialogHeaderComponent } from "../../../../shared/components/dialog-header/dialog-header.component";

export interface PendingChangesDialogData {
  pendingChanges: TaskBankAccount;
}

@Component({
  selector: "app-pending-changes-dialog",
  imports: [MatDialogModule, DialogHeaderComponent, ButtonComponent],
  templateUrl: "./pending-changes-dialog.component.html",
  styleUrl: "./pending-changes-dialog.component.scss",
})
export class PendingChangesDialogComponent {
  readonly dialogRef = inject(MatDialogRef<PendingChangesDialogComponent>);
  readonly data: PendingChangesDialogData = inject(MAT_DIALOG_DATA);
  readonly changes = this.data.pendingChanges;
}
